export const ADMIN_ROLES = {
  ADMIN: '3',
  SUPER_ADMIN: '4'
} as const;
